import { BudgetFormDTO } from './CreateBudgetForm/BudgetFormDTO';

export const defaultBudget: BudgetFormDTO = {
  id_budget: '',
  customer: {
    phone: '',
    name: '',
    document: '',
  },
  vehicle: {
    vehicle: '',
    plate: '',
    chassi: '',
    km: '',
    lastKm: '',
  },
  services: {
    validity: '',
    productTable: [
      {
        name: '',
        quantity: '',
        unitValue: '0,00',
        total: '0,00',
      },
    ],
    serviceTable: [
      {
        name: '',
        quantity: '',
        unitValue: '0,00',
        total: '0,00',
      },
    ],
    discount: '',
    comment:
      'O orçamento está sujeito a alterações após a desmontagem do veículo',
    images: [],
    total: '',
  },
};
